import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { Icon } from '@/common/components/Icons/Icon';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { IllustrationTwoCard } from '@/common/components/Illustrations/IllustrationTwoCard';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { useCurrentMealPaymentStrategy } from '@/common/utils/meal-voucher';
import { Href, useRouter } from 'expo-router';
import { ITSinglePaymentCardModal } from './ITSinglePaymentCardModal/ITSinglePaymentCardModal';

export function ITSinglePaymentCard() {
  const { t } = useTranslation();
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const { strategy, isLoading } = useCurrentMealPaymentStrategy();

  const onCloseModal = (route: Href) => {
    setShowModal(false);
    router.navigate(route);
  };

  if (isLoading || strategy === 'card') {
    return null;
  }

  if (strategy === 'credits') {
    return (
      <>
        <CardAction
          title={t('dashboard.home.it.single_payment.credits.title')}
          description={t(
            'dashboard.home.it.single_payment.credits.description'
          )}
          backgroundColor="accentSecondary20"
          size="md"
          illustration={{
            asset: (
              <IllustrationImage
                source={require('@/assets/illustrations/illustration-woman.png')}
                width={80}
                height={110}
                transition={250}
              />
            ),
          }}
          action={<Icon icon="chevron-right" />}
          onPress={() => {
            AnalyticsService.trackCustomEvent(
              'single_transaction_launching_strategy_credits_banner_home_clicked'
            );
            setShowModal(true);
          }}
        />
        {showModal && (
          <ITSinglePaymentCardModal
            onClose={() => onCloseModal(ROUTES.MEAL_VOUCHER_PAYMENT_AUTOMATIC)}
          />
        )}
      </>
    );
  }

  return (
    <>
      <CardAction
        title={t('dashboard.home.it.single_payment.none.title')}
        description={t('dashboard.home.it.single_payment.none.description')}
        backgroundColor="accentSecondary20"
        size="md"
        illustration={{
          asset: <IllustrationTwoCard width={100} height={100} />,
        }}
        action={<Icon icon="chevron-right" />}
        onPress={() => {
          AnalyticsService.trackCustomEvent(
            'single_transaction_launching_strategy_no_strategy_banner_home_clicked'
          );
          setShowModal(true);
        }}
      />
      {showModal && (
        <ITSinglePaymentCardModal
          onClose={() => onCloseModal(ROUTES.MEAL_VOUCHER_PAYMENT)}
        />
      )}
    </>
  );
}
